/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Await_Print_ButtonInputs */

const vi_await_print_button = /** @type {(inputs: Await_Print_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In phiếu yêu cầu đóng gói`)
};

/**

* @param {Await_Print_ButtonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const await_print_button = /** @type {((inputs?: Await_Print_ButtonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Await_Print_ButtonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_await_print_button(inputs)
});